const ADD_DISCOUNT_MASTER = "ADD_DISCOUNT_MASTER";
const UPDATE_DISCOUNT_MASTER = "UPDATE_DISCOUNT_MASTER";
const DELETE_DISCOUNT_MASTER = "DELETE_DISCOUNT_MASTER";
const DISCOUNT_MASTERS = "DISCOUNT_MASTERS";
const ADD_DISCOUNT_MASTER_ERROR = "ADD_DISCOUNT_MASTER_ERROR";
const DISCOUNT_MASTER_DETAILS = "DISCOUNT_MASTER_DETAILS";

export {
	ADD_DISCOUNT_MASTER,
	UPDATE_DISCOUNT_MASTER,
	DELETE_DISCOUNT_MASTER,
	DISCOUNT_MASTERS,
	ADD_DISCOUNT_MASTER_ERROR,
	DISCOUNT_MASTER_DETAILS,
};
